import { IFeatureExportsStore } from 'thunderbolt-feature-exports'
import { name } from './symbols'
import { ISiteScrollBlockerServiceConfig } from '@wix/site-scroll-blocker-service'

const isPublicSegment = process.env.PACKAGE_NAME !== 'thunderbolt-ds'
const shouldBlockScrollWithoutVar = isPublicSegment

export const getSiteScrollBlockerConfig = (
	siteScrollBlockerExports: IFeatureExportsStore<typeof name>
): ISiteScrollBlockerServiceConfig => {
	return {
		onSiteScrollBlockChanged: (status) => {
			siteScrollBlockerExports.export({
				isScrollingBlocked: status,
			})
		},
		shouldBlockScrollWithoutVar,
	}
}
